<template>
  <!-- config.conditions -->
  <!-- [ videoURL, watchPercentRequired, showTimeline ] -->
  <div class="video-field">
    <VuePlyr
      ref="plyr"
      :options="{
        fullscreen: { enabled: false },
        settings: [],
        controls: config.conditions[2].value ? ['play', 'progress'] : ['play']
      }"
      :emit="['ready', 'timeupdate']"
      @timeupdate="updatePlayTime"
    >
      <!-- :emit="[, 'timeupdate']"
      -->
      <div class="plyr__video-embed">
        <iframe
          :src="config.conditions[0].value"
          allowfullscreen
          allowtransparency
        >
        </iframe>
      </div>
    </VuePlyr>
  </div>
</template>

<script>
import VuePlyr from 'vue-plyr';
export default {
  components: { VuePlyr },
  props: {
    value: {
      required: true
    },
    config: {
      required: true
    }
  },
  methods: {
    updatePlayTime () {
      const player = this.$refs.plyr.player
      const totalDuration = player.duration;
      const currentTime = player.currentTime;
      this.$emit('input', Math.round(currentTime / totalDuration * 100));
    }
  }
}
</script>